export enum ProductVisibilityTypes {
    NotAvailable = "NOT_AVAILABLE",
    TemporaryNotAvailable = "TEMPORARY_NOT_AVAILABLE",
    OnlyAvailableInStore = "ONLY_AVAILABLE_IN_STORE",
    Free = "FREE",
    Delivery = "DELIVERY",
    Collect = "COLLECT",
    DeliveryAndCollect = "DELIVERY_AND_COLLECT",
    CollectAndExpressDelivery = "COLLECT_AND_EXPRESS_DELIVERY",
    DeliveryAndExpressDeliveryAndCollect = "DELIVERY_AND_EXPRESS_DELIVERY_AND_COLLECT",
    Offline = "OFFLINE",
    Default = "DEFAULT",
}

export enum SearchSort {
    Default = "",
    PriceDescending = "-price",
    PriceAscending = "price",
}

export enum IndexUrlParamPrefix {
    Product = "p",
    Content = "c",
}

export enum StorageKeys {
    CartsMerged = "carts_merged",
    DeliveryType = "delivery_type",
    CustomerEmail = "customer_email",
    GuestEmail = "guest_email",
    CustomerFirstName = "customer_firstName",
    CustomerLastName = "customer_lastName",
    ShouldCall = "should_call_",
    PreferredStore = "preferred-store",
    BonusCardRequested = "bonuscard_requested",
    ProductComparisonSkuList = "product_comparison_sku_list",
    RecentlyViewedProducts = "recentlyViewed",
    PreviousCartData = "previousCartData",
    PreferredStoreLocalStorageKey = "preferredStoreId",
    LocalWishlist = "localWishlist",
    CartStoreLocalStorageKey = "cachedCartStoreId",
    AlgoliaSearchQueryTracking = "algolia_query_tracking",
    AlgoliaUserToken = "algolia_user_token",
    AlgoliaAuthenticatedUserToken = "algolia_authenticated_user_token",
    AlgoliaDynamicFacetNamesAmount = "algolia_dynamicFacetNames_amount",
    AlgoliaDynamicFacetNamesCutoff = "algolia_dynamicFacetNames_cutoff",
    AlgoliaParameters = "algolia_parameters",
    ScrollPosition = "scroll_position",
}

export enum BonusCardStatus {
    NoCard = "NO_CARD",
    Requested = "REQUESTED",
    CardOnRoute = "CARD_ON_ROUTE",
    HasCard = "HAS_CARD",
}

export enum DeliveryTimeUnits {
    Hours = "HOURS",
    Weekday = "WEEKDAY",
    Weekdays = "WEEKDAYS",
    Week = "WEEK",
    Weeks = "WEEKS",
}

export enum AlgoliaIndexName {
    Products = "product",
    QuerySuggestions = "query_suggestions",
    Categories = "categories",
    ContentPages = "contentpages",
    PriceDesc = "product_price_desc",
    PriceAsc = "product_price_asc",
}

export enum DeliveryTypes {
    HomeDelivery = "HOME_DELIVERY",
    ClickAndCollect = "PICKUP_IN_STORE",
}

export enum StockLevels {
    NoStock = "NO_STOCK",
    InStock = "IN_STOCK",
    LowStock = "LOW_STOCK",
    UnknownStock = "UNKNOWN_STOCK",
    NoneWithShipToStore = "NONE_WITH_SHIP_TO_STORE",
}

export enum DeliveryPromiseTypes {
    AvailableForHomeDelivery = "AVAILABLE_FOR_HOME_DELIVERY",
    AvailableForS2S = "AVAILABLE_FOR_S2S",
    AvailableForPickUpInStore = "AVAILABLE_FOR_CLICK_AND_COLLECT",
    OnlyAvailableOffline = "ONLY_AVAILABLE_OFFLINE",
    NoStock = "UNAVAILABLE",
}

export enum CheckoutSteps {
    login = "login",
    account = "account",
    payment = "payment",
    confirmation = "confirmation",
}

export enum PromoPackTypes {
    ACTIEPRIJS = "ACTIEPRIJS",
    COMBINATIE_PRIJS = "COMBINATIE_PRIJS",
    EXTRA_BONUSPUNTEN = "EXTRA_BONUSPUNTEN",
    GRATIS_ARTIKEL = "GRATIS_ARTIKEL",
    KORTING_BEDRAG = "KORTING_BEDRAG",
    KORTING_PROCENT = "KORTING_PROCENT",
    DOCUMENT_KORTING = "DOCUMENT_KORTING",
    KORTING_PROCENT_UITZ = "KORTING_PROCENT_UITZ",
    FOLDERPRIJS = "FOLDERPRIJS",
    OUTLETPRIJS = "OUTLETPRIJS",
    CASHBACK = "CASHBACK",
    GRATIS_TRANSPORTKOST = "GRATIS_TRANSPORTKOST",
    NIEUW = "NIEUW",
    ZBON = "ZBON",
    ZBOP = "ZBOP",
}

export enum CounterDirections {
    DOWN = "down",
    UP = "up",
}

export enum CounterTheme {
    DARK = "dark",
    LIGHT = "light",
}

export enum CustomerOrderStatus {
    Created = "CREATED",
    PartiallyAvailable = "PARTIALLY_AVAILABLE",
    Available = "AVAILABLE",
    PartiallyCollected = "PARTIALLY_COLLECTED",
    Collected = "COLLECTED",
    Cancelled = "CANCELLED",
    CancelPending = "CANCEL_PENDING",
    TrackTrace = "TRACK_TRACE",
    MultipleTrackTrace = "MULTIPLE_TRACK_TRACE",
}

export enum PlaceOrderResultCode {
    SUCCESS = "SUCCESS",
    IDENTIFY = "IDENTIFY",
    CHALLENGE = "CHALLENGE",
    REDIRECT = "REDIRECT",
    PRESENT_QR = "PRESENT_SHOPPER",
    PRESENT_PAYCONIQ = "PRESENT_PAYCONIQ",
    PENDING = "PENDING",
}

export enum LoginFlows {
    LOGIN = "LOGIN",
    CHECKOUT = "CHECKOUT",
}

export enum GiftCardStatus {
    Valid = "VALID",
    Expired = "EXPIRED",
    Locked = "LOCKED",
    Blocked = "BLOCKED",
    NoBalance = "NO_BALANCE",
    NotFound = "NOT_FOUND",
}

export enum GiftCardType {
    Gift = "CADEAU",
    HappyHolidays = "PRETTIGE_FEESTEN",
    Congratulations = "GEFELICITEERD",
    Digital = "DIGITALE_CADEAUKAART",
}

export enum PaymentTypes {
    QrCode = "qrCode",
}

export enum ApiMessage {
    CTAPresent = "CTA_PRESENT",
}

export enum BoxConditionType {
    AGE_CONDITION = "ageCondition",
    CONTEST_CONDITIONS = "contestCondition",
    PARTNER_CONDITIONS = "partnerCondition",
}

export enum ScrollOffsets {
    DEFAULT = 66,
}

export enum CustomerTypes {
    B2B = "B2B",
    B2C = "B2C",
}

export enum PaymentModes {
    MasterCard = "MASTERCARD",
    Visa = "VISA",
    Bancontact = "BANCONTACT",
    BancontactMobileQr = "BANCONTACT_QR",
    BancontactMobileApp = "BANCONTACT_MOBILE",
    GiftCard = "GIFTCARD",
    Coupon = "COUPON",
    Scheme = "SCHEME",
    Terminal = "TERMINAL",
}

export enum CallToActionTypes {
    CHANGE_TO_HOME_DELIVERY = "CHANGE_TO_HOME_DELIVERY",
    CHANGE_STORE = "CHANGE_STORE",
    CHANGE_QUANTITIES = "CHANGE_QUANTITIES",
    ACCEPT_NEGATIVE_DELIVERY_PROMISE = "ACCEPT_NEGATIVE_DELIVERY_PROMISE",
    ACCEPT_POSITIVE_DELIVERY_PROMISE = "ACCEPT_POSITIVE_DELIVERY_PROMISE",
    REMOVE_ARTICLE = "REMOVE_ARTICLE",
    CHANGE_STORE_AND_CNC = "CHANGE_STORE_AND_CNC",
    CHANGE_TO_CNC = "CHANGE_TO_CNC",
    CHOOSE_STORE = "CHOOSE_STORE",
    CHANGE_STORE_TO_ECORNER = "CHANGE_STORE_TO_ECORNER",
    REMOVE_ACCESSORY_ARTICLE = "REMOVE_ACCESSORY_ARTICLE",
}

export enum PromotionTypes {
    PROMOTION = "PROMOTION",
    COUPON = "COUPON",
}

export enum ProductImageRenditions {
    MINI = "110x82",
    XS = "146x109",
    SM = "302x226",
    MD = "440x330",
    LG = "800x600",
    XL = "1920x1440",
    ORIGINAL = "BigImage",
}

export enum HeaderKeys {
    orderIdPublic = "ORDER-ID-PUBLIC",
}

export enum Keys {
    BACKSPACE = 8,
    TAB = 9,
    ENTER = 13,
    SHIFT = 16,
    CTRL = 17,
    ALT = 18,
    ARROW_UP = 38,
    ARROW_DOWN = 40,
    META = 91,
    ESCAPE = 27,
    SPACE = 32,
    HOME = 36,
    END = 35,
    N = 78,
    P = 80,
}

export enum KeyNames {
    ARROW_UP = "ArrowUp",
    ARROW_DOWN = "ArrowDown",
    ARROW_LEFT = "ArrowLeft",
    ARROW_RIGHT = "ArrowRight",
    ENTER = "Enter",
    ESCAPE = "Escape",
    TAB = "Tab",
    SPACE = " ",
    SHIFT = "Shift",
}

export enum SalesIncentiveType {
    FolderPrijs = "FOLDERPRIJS",
    Cashback = "CASHBACK",
    EveryDayLowPrice = "EDLP",
    GratisArtikel = "GRATIS_ARTIKEL",
    ActiePrijs = "ACTIEPRIJS",
    GratisTransport = "GRATIS_TRANSPORTKOST",
    ExtraBonusPunten = "EXTRA_BONUSPUNTEN",
    CombinatiePrijs = "COMBINATIE_PRIJS",
    KortingProcent = "KORTING_PROCENT",
    OutletPrijs = "OUTLETPRIJS",
}

export enum SafetyDocumentCategory {
    SDS = "SDS",
    DOP = "DOP",
}

export enum ProductSliderSources {
    recent = "recents",
    algoliaRecommend = "algolia-recommend",
    accessory = "accessories",
    mainProduct = "mainProducts",
    algolia = "algolia",
    handPicked = "handpicked",
}

export enum ProductListSources {
    algolia = "algolia",
    handPicked = "handpicked",
}

export enum AlgoliaRecommendZones {
    productPage = "1",
    shoppingCart = "2",
    homePage = "3",
    addToCart = "4",
}

export enum Countries {
    BE = "BE",
    FR = "FR",
}

export enum AddressValidationStatus {
    NoValidationNeeded = "NO_VALIDATION_NEEDED", // Buitenland
    OverruledByCustomer = "OVERRULED_BY_CUSTOMER", // customer input
    Unknown = "UNKNOWN", // onbekend
    Validated = "VALIDATED", // BPOST validated

    Invalid = "INVALID", // Internal FE status
    Closed = "CLOSED", // Internal FE status
}

export enum AddressTypes {
    Delivery = "DELIVERY",
    Payment = "PAYMENT",
}

export enum BPOSTErrorSeverity {
    Warning = "warning",
    Error = "error",
}

// Size_width_height
export enum EmptyImages {
    Size_1_1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
    Size_146_109 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiID8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxNDYgMTA5Ij4KICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHN0eWxlPSJmaWxsOndoaXRlO2ZpbGwtb3BhY2l0eTowIiAvPgo8L3N2Zz4=",
    Size_120_90 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiID8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA0NjYgMjcwIj4KICA8cmVjdCB4PSIwIiB5PSIwIiB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHN0eWxlPSJmaWxsOndoaXRlO2ZpbGwtb3BhY2l0eTowIiAvPgo8L3N2Zz4=",
}

export enum CookieList {
    ECORDER_ID = "ECORNER_ID",
}

export enum WeekDays {
    MONDAY = "MONDAY",
    TUESDAY = "TUESDAY",
    WEDNESDAY = "WEDNESDAY",
    THURSDAY = "THURSDAY",
    FRIDAY = "FRIDAY",
    SATURDAY = "SATURDAY",
    SUNDAY = "SUNDAY",
}

export enum PaymentStatus {
    PAID = "PAID",
    NOT_PAID = "NOT_PAID",
    PARTIALLY_PAYED = "PARTIALLY_PAID",
}

export enum ProductFieldSet {
    ProductTile = "PRODUCT_TILE",
    Basic = "BASIC",
}

export enum DiscountType {
    PERCENTAGE = "%",
    ABSOLUTE = "€",
}

export enum StorePickerModalStates {
    AddToCart = "ADD_TO_CART",
    Closed = "CLOSED",
    Open = "OPEN",
}
